import { createEntityAdapter } from "@reduxjs/toolkit";
import { WebOrderContentLine } from "./dataTypes";

export const webOrderContentLineAdapter = createEntityAdapter<WebOrderContentLine>({});
